<template lang="pug">
  lazy-load(
    v-model="loadMore"
    @on-response="({ items }) => {items.forEach((i) => i.getFaq()); units.push(items)}"
  )
    .caption.mb-4 Список тем
    data-wrapper(
      :loading="loading"
      :skeleton-items-count="2"
      :has-items="!!units.length"
      skeleton-type="list-item"
      :colsProps="{ cols: 12, md: 12, sm: 12, xl: 12 }"
    )
    v-row(no-gutters)
      v-col(cols="12" md="8" xl="6")
        v-expansion-panels.px-2.ma-0(
          accordion flat
        )
          v-expansion-panel.transparent.sdo-card.mb-4(
            v-for="(unit, idx) in units"
            :key="unit.id"
          )
            v-expansion-panel-header.ma-0
              .d-flex.align-center
                .mr-4: v-icon(size="28" color="secondary") mdi-book-open-variant
                div
                  .text-body-1 {{unit.title}}
                  .caption Вопросы - {{ unit.faq.length }}
            v-expansion-panel-content.pa-0.ma-0
              .d-flex.mb-4
                v-chip-group(
                  v-model="searchStatus"
                  mandatory multiple
                  column
                )
                  v-chip(
                    :outlined="!searchStatus.includes(3)"
                    color="secondary  lighten-1" filter :value="3" small label
                    ) Черновик
                  v-chip(
                    :outlined="!searchStatus.includes(1)"
                    color="warning" filter :value="1" small label
                    ) Заявка
                  v-chip(
                    :outlined="!searchStatus.includes(4)"
                    color="success" filter :value="4" small label
                  ) Опубликованные
                v-btn.ml-auto(
                  color="primary"
                  text
                  :icon="$vuetify.breakpoint.smAndDown"
                  :outlined="$vuetify.breakpoint.smAndDown"
                  @click="openAddQuestion(unit)"
                )
                  span(v-if="!$vuetify.breakpoint.smAndDown") Добавить вопрос
                  v-icon(:right="!$vuetify.breakpoint.smAndDown") mdi-plus
              .text-body-1.mb-4(v-if="!unit.faq.length") Вопросов еще нет...

              //- TODO: доделать драгабл когда будет бэк
              draggable.justify-center(
                v-else
                v-model="unit.faq"
                :disabled="searchStatus.length !== 3"
                :component-data="{group: true,'leave-absolute': true}"
                @change="changeOrder(unit, $event)"
              )
                v-list-item(v-for="item in filtered(unit.faq)" :key="item.id" link).mb-4
                  v-list-item-icon.mr-4.mt-3
                    tooltip-wrap(
                      :text="item.statusData.text"
                    )
                      v-icon(:color="item.statusData.color") mdi-message-question-outline
                    v-icon(size="28" color="secondary" v-if="false").pt-2 mdi-drag
                  v-list-item-content
                    .text-body-1 {{ item.question }}
                    .text-body-2.grey--text.text-darken-2
                      v-icon(small color="primary").mr-1 mdi-message-processing-outline
                      span.caption Ответ:
                      span.secondary--text.ml-2 {{ item.answer }}
                    .caption от: {{ item.owner.full_name}}
                  v-list-item-icon.mt-2
                    v-menu
                      template(#activator="{ on }")
                        v-btn(
                          icon
                          v-on="on"
                        ): v-icon mdi-menu
                      v-sheet(min-width="250" dark).secondary.pa-3

                        v-list-item.secondary.lighten-1.mb-2.py-0(
                          v-if="STATUSES.active === item.status"
                          @click="unPublish(item)"
                        )
                          v-list-item-action.mr-4: v-icon() mdi-draw-pen
                          v-list-item-content.text-body-2.py-0: strong в Черновик
                        template(v-if="STATUSES.request === item.status")
                          v-list-item.secondary.lighten-1.mb-2.py-0(
                            @click="decline(item)"
                          )
                            v-list-item-action.mr-4: v-icon() mdi-close
                            v-list-item-content.text-body-2.py-0: strong Отклонить
                          v-list-item.secondary.lighten-1.mb-2.py-0(
                            @click="accept(item)"
                          )
                            v-list-item-action.mr-4: v-icon() mdi-check
                            v-list-item-content.text-body-2.py-0: strong Принять
                        template(v-else)
                          v-list-item.secondary.lighten-1.mb-2.py-0(
                            v-if="STATUSES.draft === item.status"
                            @click="publish(item)"
                          )
                            v-list-item-action.mr-4: v-icon() mdi-check
                            v-list-item-content.text-body-2.py-0: strong Опубликовать
                          v-list-item.secondary.lighten-1.mb-2(
                            @click="openAddQuestion(unit, item)"
                          )
                            v-list-item-action.mr-4: v-icon() mdi-pencil
                            v-list-item-content.text-body-2.py-0: strong Редактировать
                          v-list-item.secondary.lighten-1(
                            @click="deleteQuestion(item, unit)"
                          )
                            v-list-item-action.mr-4: v-icon() mdi-delete
                            v-list-item-content.text-body-2.py-0: strong Удалить

      v-col.px-4(cols="12" md="4")
        //- v-card.sdo-card
        //-   span test
    portal(to="addQuestion.dialog" v-slot="{ close, attrs }")
      v-sheet.sdo-card
        v-list-item
          v-list-item-content
            .text-h6 {{ attrs.faq.id ? 'Редактирование вопроса' : 'Добавление вопроса'}}
          v-list-item-action: v-btn(icon @click="close"): v-icon mdi-close
        .px-4.mb-4
          api-form(
            v-model="form"
            :fields="fields"
            :successCallback="(data) => success(data, attrs.faq, attrs.unit)"
            :method="(data) => save(data, attrs.unit, attrs.faq)"
          )
</template>
<script>
import GptSettings from '@/components/GPTSettings/index.vue';
import UnitFaq from '@/models/list/UnitFaq';
import draggable from 'vuedraggable';

const STATUSES = {
  request: 1,
  canceled: 2,
  draft: 3,
  active: 4,
};

export default {
  components: {
    GptSettings,
    draggable,
  },
  data() {
    return {
      UnitFaq,
      STATUSES,
      searchStatus: [1, 3, 4],
      tabs: 0,
      cards: [],
      form: {},
      fields: [
        {
          text: 'Текст вопроса',
          value: 'question',
          rules: 'required',
          component: 'v-text-field',
          component_attrs: {
            filled: true,
            rounded: true,
          },
        },
        {
          text: 'Текст ответа',
          value: 'answer',
          rules: 'required',
          component: 'v-text-field',
          component_attrs: {
            filled: true,
            rounded: true,
          },
        },
      ],
      course: {},
      loadMore: null,
      loading: false,
      units: [],
    };
  },
  created() {
    this.fetchCourse();
    this.getUnits();
  },
  methods: {
    async changeOrder(unit, { moved }) {
      const { oldIndex, newIndex } = moved;
      const action = oldIndex > newIndex ? -1 : 1;
      let count = 0;
      for (let start = oldIndex; start !== (newIndex + action); start += action) {
        unit.faq[start].update(
          { data: { question: { sort_order: oldIndex + (count * action) } } },
          {},
          true,
        );
        count += 1;
      }
    },

    filtered(list) {
      return list.filter((i) => this.searchStatus.includes(i.status));
    },
    async accept(faq) {
      const noAssign = true;
      await faq.update({ data: { question: { status: 3, order: 1 } } }, {}, noAssign).then(() => {
        this.$toasted.success('Успех');
        faq.status = 3;
      });
    },
    async decline(faq) {
      const noAssign = true;
      await faq.update({ data: { question: { status: 2 } } }, {}, noAssign).then(() => {
        this.$toasted.success('Успех');
        faq.status = 2;
      });
    },
    async publish(faq) {
      const noAssign = true;
      await faq.update({ data: { question: { status: 4 } } }, {}, noAssign).then(() => {
        this.$toasted.success('Успех');
        faq.status = 4;
      });
    },
    async unPublish(faq) {
      const noAssign = true;
      await faq.update({ data: { question: { status: 3 } } }, {}, noAssign).then(() => {
        this.$toasted.success('Успех');
        faq.status = 3;
      });
    },
    async deleteQuestion(faq, unit) {
      this.$modals.show('confirm-controller', {
        dialogProps: {
          width: 800,
        },
        method: async () => {
          await faq.delete().then(() => {
            this.$toasted.success('Успех');
            const index = unit.faq.findIndex(({ id }) => id === faq.id);
            unit.faq.splice(index, 1);
            this.$modals.close();
          });
        },
      });
    },
    success({ data }, faq, unit) {
      if (faq.id) {
        const moduleItem = unit.faq.find((i) => i.id === faq.id);
        Object.assign(moduleItem, { ...data.data, answer: this.form.answer });
        this.$toasted.success('Успех');
      } else unit.faq.push(new UnitFaq({ ...data.data, answer: { answer: this.form.answer } }));
      this.$modals.close();
    },
    save({ data }, unit, faq) {
      const payload = {
        question: {
          ...faq.id ? {} : { status: 3 },
          question: data.question,
          course_unit_id: unit.id,
        },
        answer: {
          answer: data.answer,
        },
      };
      if (faq.id) {
        const noAssign = true;
        return faq.update({ data: payload }, { expand: 'answer' }, noAssign);
      }
      return this.$api.unitFaq.create(payload);
    },
    openAddQuestion(unit, faq = {}) {
      this.form = faq;
      this.$modals.show('dialog-portal', {
        inputValue: 'addQuestion',
        unit,
        faq,
      });
    },
    async fetchCourse() {
      const courseParams = {
        expand: 'edit,tasks,prior_records',
      };
      const { item } = await this.$api.courses.show(this.$route.params.id, courseParams);
      this.course = item;
    },
    async getUnits() {
      this.loading = true;
      const params = {
        'search[is_modular]': 0,
      };
      const { items, loadMore } = await this.$api.courses.courseUnitIndex(
        this.$route.params.id,
        params, { hideErrorToasts: true },
      );
      items.forEach((i) => i.getFaq({ 'search[status]': [1, 3, 4] }));
      this.loadMore = loadMore;
      this.units = items;
      this.loading = false;
    },
  },
};
</script>
